var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"ide-ia-progress-bar"},[_c('div',{staticClass:"ide-ia-progress-fill",style:({ width: _vm.progress + '%' })})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }